import React, { Component } from 'react';
import Dialog from './../UiComponents/Dialog';
import PropTypes from 'prop-types';
import CallTemplate from './../../call/call';
import MeetingTemplate from './../../call/meeting';
import styles from './call.module.scss';

class Call extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true
        };
    }


    render() {
        const { callDetail, closeCallContainer, endCall, endMeeting, postSurveyResponse, terminateCall, setCallEndedFlag, getTimeData, actors } = this.props;
        return <React.Fragment>
            {
                this.state.isOpen ?
                    < Dialog
                        overlayClassName={styles.dialog}
                        containerClassName={styles['overlay-container']}
                        isFooterNeeded={false}
                        hideOverflow={true}
                        contentStyle={{ overflow: 'inherit', alignItems: 'baseline' }}
                    >
                        {
                            callDetail.type === "call" ?
                                <CallTemplate
                                    callDetail={callDetail}
                                    closeCallContainer={closeCallContainer}
                                    endCall={endCall}
                                    postSurveyResponse={postSurveyResponse}
                                    terminateCall={terminateCall}
                                    setCallEndedFlag={setCallEndedFlag}
                                    getTimeData={getTimeData}
                                    actors={actors}
                                    //For tutorial
                                    tutorial={this.props.tutorial}
                                    startTutorial={this.props.startTutorial}
                                    stopTutorial={this.props.stopTutorial}
                                    addStepsToTutorial={this.props.addStepsToTutorial}
                                    updateStepNumber={this.props.updateStepNumber}
                                    setEndTutorialPopup={this.props.setEndTutorialPopup}
                                    //Self Actor id
                                    selfActor={this.props.selfActor}
                                />
                                :
                                <MeetingTemplate
                                    meetingDetail={callDetail}
                                    closeCallContainer={closeCallContainer}
                                    endMeeting={endMeeting}
                                    postSurveyResponse={postSurveyResponse}
                                    terminateCall={terminateCall}
                                    setCallEndedFlag={setCallEndedFlag}
                                    getTimeData={getTimeData}
                                    actors={actors}
                                    //For tutorial
                                    tutorial={this.props.tutorial}
                                    //Self Actor id
                                    selfActor={this.props.selfActor}
                                />
                        }
                    </Dialog >
                    :
                    null
            }
        </React.Fragment>;
    }
}

Call.propTypes = {};

Call.defaultProps = {};

export default Call;


// WEBPACK FOOTER //
// /src/components/call/Call.js